module.exports = __webpack_public_path__ + "img/wms-hx-line.f5723d9d.svg";